module.exports = __webpack_public_path__ + "img/avatar4.066cd967.png";